import { Box, styled } from '@withjoy/joykit';

export const Divider = styled(Box)`
  margin: ${props => props.theme.space[8]} auto;
  height: 1px;
  width: 332px;
  background-color: ${props => props.theme.colors.mono3};
`;

export const CreditCardWrapper = styled.div`
  width: 68px;
  height: 68px;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.07), 0px 14px 54px 0px rgba(44, 41, 37, 0.06);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 70%;
`;
